import { useNavigate, useLocation } from 'react-router-dom';

export const useSectionNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    // Offset clears the fixed header (90px, 70px scrolled) + 8px breathing room.
    // Matches .sw-section scroll-margin-top: 96px so anchor and JS scrolling agree.
    const HEADER_OFFSET = 96;
    if (location.pathname !== '/') {
      // Navigate to home page with a state telling it which section to scroll to
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - HEADER_OFFSET,
          behavior: 'smooth',
        });
      }
    }
  };

  return { scrollToSection };
};
